<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <path d="M33.64,27.26l-4.47-.02-5.46-5.64.05-5.8c0-4.05,2.5-6.67,6.37-6.67h2.74c3.36,0,6.19,3.06,6.19,6.69,0,3.04.01,5.17.01,5.18v.61s-5.44,5.66-5.44,5.66ZM30.44,24.25h1.93s3.71-3.85,3.71-3.85c0-.84,0-2.5,0-4.58,0-1.74-1.31-3.69-3.19-3.69h-2.74c-2.79,0-3.37,2-3.37,3.69l-.04,4.58,3.72,3.85Z" fill="currentcolor"/>
    <path d="M14.57,21.25l-4.47-.02-5.46-5.64.05-5.8c0-4.05,2.5-6.67,6.37-6.67h2.74c3.36,0,6.19,3.06,6.19,6.69,0,3.04.01,5.17.01,5.18v.61s-5.44,5.66-5.44,5.66ZM11.37,18.24h1.93s3.71-3.85,3.71-3.85c0-.84,0-2.5,0-4.58,0-1.74-1.31-3.69-3.19-3.69h-2.74c-2.79,0-3.37,2-3.37,3.69l-.04,4.58,3.72,3.85Z" fill="currentcolor"/>
    <polygon points="3 41.87 0 41.87 0 28.55 4.77 23.87 10.59 23.87 12.3 25.61 13.99 23.87 20.61 23.87 24.59 27.86 24.59 31.01 21.59 31.01 21.59 29.1 19.37 26.87 15.25 26.87 12.31 29.89 9.34 26.87 5.99 26.87 3 29.81 3 41.87" fill="currentcolor"/>
    <polygon points="45 41.87 42 41.87 42 35.93 39.07 33.09 34.09 33.1 31.21 36.08 28.39 33.11 23.69 33.12 20.79 35.92 20.8 40.37 17.8 40.38 17.79 34.65 22.47 30.13 29.68 30.11 31.23 31.74 32.82 30.1 40.29 30.09 45 34.66 45 41.87" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>